import angular from 'angular';
import schedule from '../../utils/schedules';

const module = angular.module('whyline.components.exactSchedule', []);

const exactScheduleComponent = {
  bindings: {
    schedule: '<',
  },
  templateUrl: '/templates/components/modals/schedule/exact-schedules.html',
  controller($scope) {
    const $ctrl = this;
    $scope.hours = schedule.getHour();
    $scope.minutes = schedule.getMinutes();

    $scope.applyToAll = day => {
      schedule.applyToAll(day, this.schedule, true);
      const hasSecondPeriod = day.hasSecondPeriod;
      this.schedule.forEach(day => {
        $scope.setHasSecondPeriod(day, hasSecondPeriod);
      });
    };
    $scope.setHasSecondPeriod = (day, hasSecondPeriod) => {
      day.hasSecondPeriod = hasSecondPeriod;
    };
  },
};

module.exports = module.component('exactSchedules', exactScheduleComponent);
